module.exports = __webpack_public_path__ + "4ba2a48420ef746257b49cf868490a8d.png";